import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const slice = createSlice({
  name: 'settings',
  initialState: {
    visitTypes: [],
    banners: [],
    states: [],
    statePaginationData: {},
    errorMsg: '',
    bannerImage: '',
    bannerPaginationData: {},
    bannerLoading: false,
    stateLoading: false,
    addStateApiSuccess: false,
    deleteStateApiSuccess: false,
    editStateApiSuccess: false,
    stateApiError: null,
    // Taluk
    talukList: [],
    talukListLoading: false,
    talukDetailsLoading: false,
    updateTalukApi: false,
    talukDetailsData: {},
    talukPaginationData: {},
    ApiError: '',
    modalOpen: false,

    // district
    districtLoading: false,
    updateDistrictList: false,
    districtList: [],
    districtPaginationData: {},
  },
  reducers: {
    //uploadImage
    uploadImage: (state) => {
      state.bannerImage = ''
    },
    uploadImageSuccess: (state, { payload }) => {
      state.bannerImage = payload?.payload?.data?.path
    },
    uploadImageFailed: (state) => {},

    persistVisitType: (state, { payload }) => {
      let visitType = localStorage.getItem('visitType')
      state.visitTypes = JSON.parse(visitType)
    },

    //addBanner
    addBannerData: (state, { payload }) => {
      const last = state.banners[state.banners.length - 1]?.id || 0
      state.banners = [
        ...state.banners,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
    },
    addBannerSuccess: (state) => {},
    addBannerFailed: (state) => {},

    //updateBanner
    updateBannerData: (state, { payload }) => {
      state.banners = state.banners.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateBannerDataSuccess: (state) => {},
    updateBannerDataFailed: (state) => {},

    //getBanner
    getBannerData: (state) => {
      state.bannerLoading = true
      state.errorMsg = ''
    },
    getBannerDataSuccess: (state, { payload: { payload } }) => {
      state.bannerLoading = false
      state.banners = payload.data
      state.bannerPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getBannerDataFailed: (state, { payload }) => {
      state.bannerLoading = false
    },

    //deleteBanner
    deleteBannersData: (state, { payload }) => {
      state.banners = state.banners.filter((item) => item.id !== payload)
    },
    deleteBannerSuccess: (state, { payload }) => {},
    deleteBannerFailed: (state, { payload }) => {},

    //update Speciality

    //Get State
    getStateData: (state) => {
      state.stateLoading = true
      state.errorMsg = ''
    },
    getStateDataSuccess: (state, { payload }) => {
      state.stateLoading = false
      state.states = payload.payload.data
      state.statePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getStateDataFailed: (state, { payload }) => {
      state.token = null
      state.stateLoading = false
    },

    //Add State
    addStateData: (state, { payload }) => {
      //state.updateStateList = false
      state.stateLoading = false
      const last = state.states[state.states.length - 1]?.id || 0
      state.states = [...state.states, { id: last + 1, ...payload, created_at: moment().format() }]
    },
    addStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    //delete State
    deleteStateData: (state, { payload }) => {
      state.stateLoading = false
      state.states = state.states.filter((item) => item.id !== payload)
    },
    deleteStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    //update State
    updateStateData: (state, { payload }) => {
      // state.stateLoading = true
      state.states = state.states.map((item) => {
        if (item.id === payload.id) {
          return { ...item, ...payload.data }
        } else {
          return item
        }
      })
    },
    updateStateDataSuccess: (state, { payload }) => {
      state.updateStateList = true
      state.stateLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateStateDataFailed: (state, { payload }) => {
      state.stateLoading = false
      alert(payload)
    },

    // Taluk Apis
    talukListApiCall: (state, { payload }) => {
      state.talukListLoading = true
    },
    talukListApiSuccess: (state, { payload }) => {
      state.talukListLoading = false
      state.talukList = payload?.payload?.data
      state.talukPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    talukListApiFailed: (state, { payload }) => {
      state.talukListLoading = false
    },

    // Add Taluk
    addTalukApiCall: (state, { payload }) => {
      state.updateTalukApi = false
      state.modalOpen = false
    },
    addTalukApiSuccess: (state, { payload }) => {
      state.updateTalukApi = true
      state.apiError = payload.payload
      state.modalOpen = true
    },
    addTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Taluk
    updateTalukApiCall: (state, { payload }) => {
      state.updateTalukApi = false
      state.modalOpen = false
      state.talukList = state.talukList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateTalukApiSuccess: (state, { payload }) => {
      state.ApiError = payload.payload
      state.modalOpen = true
      state.updateTalukApi = true
    },
    updateTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // delete Taluk
    deleteTalukApiCall: (state, { payload }) => {
      let updateTalukList = state.talukList?.filter((item) => item.id !== payload?.id)
      state.talukList = updateTalukList
    },
    deleteTalukApiSuccess: (state, { payload }) => {
      state.ApiError = payload.payload
      state.modalOpen = true
    },
    deleteTalukApiFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    // Taluk Details
    talukDetailsApiCall: (state, { payload }) => {
      state.talukDetailsLoading = true
    },
    talukDetailsSuccess: (state, { payload }) => {
      state.talukDetailsLoading = false

      state.talukDetailsData = payload.payload.data
    },
    talukDetailsFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },
    resetProviderManagementError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
    //district
    getDistrictApiData: (state, { payload }) => {
      state.errorMsg = ''
      state.districtLoading = true
    },
    getDistrictDataSuccess: (state, { payload: { payload } }) => {
      state.districtLoading = false
      state.districtList = payload?.data
      state.districtPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getDistrictDataFailed: (state, { payload }) => {
      state.districtLoading = false
    },

    // add district
    addDistrictApiData: (state, { payload }) => {
      state.districtLoading = true
      state.updateDistrictList = false
    },
    addDistrictApiSuccess: (state, { payload }) => {
      state.updateDistrictList = true
      state.districtLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addDistrictApiFailed: (state, { payload }) => {
      state.districtLoading = false
      alert(payload)
    },

    // update district
    updateDistrictApiData: (state, { payload }) => {
      state.districtLoading = true
      state.updateDistrictList = false
      state.districtList = state.districtList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateDistrictApiSuccess: (state, { payload }) => {
      state.updateDistrictList = true
      state.districtLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateDistrictApiFailed: (state, { payload }) => {
      state.districtLoading = false
      alert(payload)
    },
    // delete district
    deleteDistrictApiData: (state, { payload }) => {
      state.districtLoading = true
      state.updateDistrictList = false
      let updatedDistrictList = state.districtList?.filter((item) => item.id !== payload?.id)
      state.districtList = updatedDistrictList
    },
    deleteDistrictApiSuccess: (state, { payload }) => {
      state.updateDistrictList = true
      state.districtLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteDistrictApiFailed: (state, { payload }) => {
      state.districtLoading = false
      alert(payload)
    },

    resetSettingError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  persistVisitType,

  //addBanner
  addBannerData,
  addBannerSuccess,
  addBannerFailed,
  //updateBanner
  updateBannerData,
  updateBannerDataSuccess,
  updateBannerDataFailed,
  //getBanner
  getBannerData,
  getBannerDataSuccess,
  getBannerDataFailed,
  //deleteBanner
  deleteBannersData,
  deleteBannerSuccess,
  deleteBannerFailed,

  //get state
  getStateData,
  getStateDataFailed,
  getStateDataSuccess,
  //add state
  addStateData,
  addStateDataSuccess,
  addStateDataFailed,
  //delete state
  deleteStateData,
  deleteStateDataSuccess,
  deleteStateDataFailed,
  //update state
  updateStateData,
  updateStateDataSuccess,
  updateStateDataFailed,
  // Taluk
  talukListApiCall,
  talukListApiSuccess,
  talukListApiFailed,

  // Add Taluk
  addTalukApiCall,
  addTalukApiSuccess,
  addTalukApiFailed,

  // Update Taluk
  updateTalukApiCall,
  updateTalukApiSuccess,
  updateTalukApiFailed,

  // delete Taluk
  deleteTalukApiCall,
  deleteTalukApiSuccess,
  deleteTalukApiFailed,

  // Taluk Details
  talukDetailsApiCall,
  talukDetailsSuccess,
  talukDetailsFailed,
  resetProviderManagementError,

  //uploadImage
  uploadImage,
  uploadImageSuccess,
  uploadImageFailed,

  //getDistrict
  getDistrictApiData,
  getDistrictDataSuccess,
  getDistrictDataFailed,

  // add district
  addDistrictApiData,
  addDistrictApiSuccess,
  addDistrictApiFailed,

  // update district
  updateDistrictApiData,
  updateDistrictApiSuccess,
  updateDistrictApiFailed,
  // delete district
  deleteDistrictApiData,
  deleteDistrictApiSuccess,
  deleteDistrictApiFailed,

  resetSettingError,
} = slice.actions

export default slice.reducer
